// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import lightbulb02Icon from "@/assets/icons/lightbulb-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Lightbulb02IconProps = Omit<IconProps, "name">;

export function Lightbulb02Icon(props: Lightbulb02IconProps): React.ReactNode {
  return <Icon name={lightbulb02Icon} {...props} />;
}
